import { LuLoaderCircle, LuSearch, LuX } from "react-icons/lu";
import { colors, typography } from "../../../design/tokens";
import { useRef } from "react";

interface AppStoreRankingsSearchProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  onClear: () => void;
  isSearching: boolean;
  placeholder?: string;
}

export function AppStoreRankingsSearch({
  value,
  onChange,
  onSearch,
  onClear,
  isSearching,
  placeholder = "Search apps...",
}: AppStoreRankingsSearchProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && value.trim()) {
      onSearch();
    }
  };

  const handleClear = () => {
    onClear();
    // Keep focus in the input field after clearing
    inputRef.current?.focus();
  };

  return (
    <div className="relative w-full">
      <div className="relative flex items-center">
        {/* Search icon */}
        <div className="absolute left-4 pointer-events-none">
          {isSearching ? (
            <LuLoaderCircle
              className={`animate-spin ${colors.text.secondary}`}
              size={18}
            />
          ) : (
            <LuSearch className={colors.text.secondary} size={18} />
          )}
        </div>

        {/* Input */}
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className={`
            w-full
            pl-11 pr-10 py-3
            ${colors.surface.secondary}
            ${colors.text.primary}
            ${typography.size.sm}
            border border-dark-border
            rounded-xl
            placeholder:text-dark-placeholder
            focus:outline-none focus:border-primary-blue
            transition-colors
          `}
        />

        {/* Clear button */}
        {value && (
          <button
            onClick={handleClear}
            className={`absolute right-3 p-1 rounded-full hover:bg-dark-hover transition-colors ${colors.text.secondary} hover:text-white`}
          >
            <LuX size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
